import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { LoggingService } from './logging.service';
import * as StackTrace from 'stacktrace-js';
import { IError } from '../types/error';
import { Router } from '@angular/router';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor( private injector: Injector ) {}

  handleError (error) {
    const loggingService = this.injector.get(LoggingService);
    const location = this.injector.get(LocationStrategy);
    const message = error.message ? error.message : error.toString();
    const url = location instanceof PathLocationStrategy ? location.path() : '';
    const router = this.injector.get(Router);
    const errorToLog: IError = {
        message: message,
        url: url,
        stack: loggingService.getStackSync(20)
    };

    loggingService.logError(errorToLog);
    router.navigate(['/error']);
    throw error;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/global-error-handler.service.ts